import { downloadInfo } from '@/mocks/homeData';

export default function DownloadCTA() {
  return (
    <section id="download" className="w-full py-14 md:py-20 bg-background-900">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 max-w-4xl mx-auto">
          {/* QR Code */}
          <div className="flex-shrink-0">
            <div className="w-44 h-44 md:w-52 md:h-52 rounded-2xl bg-white p-3">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20QR%20code%20design%20with%20soft%20rounded%20corners%20on%20clean%20white%20background%2C%20modern%20tech%20style%2C%20simple%20geometric%20pattern%2C%20warm%20subtle%20gradient%20accents%2C%20professional%20app%20download%20graphic%20design&width=400&height=400&seq=download-qr&orientation=squarish"
                alt="下载豆花视频APP二维码"
                className="w-full h-full object-contain"
                title="豆花视频APP下载二维码"
              />
            </div>
          </div>

          {/* Text Content */}
          <div className="text-center lg:text-left flex-1">
            <h2 className="text-xl md:text-2xl font-heading font-bold text-white mb-3">
              {downloadInfo.title}
            </h2>
            <p className="text-sm text-foreground-300 leading-relaxed mb-6 max-w-md">
              {downloadInfo.description}
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start">
              <a
                href="#"
                className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-white text-foreground-900 text-sm font-medium hover:bg-foreground-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-apple-fill mr-2 text-lg"></i>
                App Store 下载
              </a>
              <a
                href="#"
                className="inline-flex items-center justify-center px-6 py-3 rounded-lg bg-primary-500 text-white text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-android-fill mr-2 text-lg"></i>
                Android 下载
              </a>
            </div>
            <p className="text-xs text-foreground-500 mt-4">
              支持 iOS 14+ / Android 8.0+ | 新用户注册即享7天免费会员
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}